import { useState } from 'react';

/**
 * A 16 px class icon from image storage. Icons exist only after a seed run with Blizzard
 * credentials, so a missing file simply renders nothing (no broken-image glyph).
 */
export function ClassIcon({ cls, url }: { cls: string; url: string | undefined }) {
  const [failed, setFailed] = useState(false);
  if (!url || failed) return null;
  return (
    <img
      className="class-icon"
      src={url}
      alt=""
      width={16}
      height={16}
      loading="lazy"
      onError={() => setFailed(true)}
      data-class={cls}
    />
  );
}
